import React, { Component } from 'react';
import { connect } from 'react-redux';
import { warningIcon, infoIcon, errorIcon } from '../../style/images';
import { PropTypes } from 'prop-types';
import { translate } from '../services';
import ReactHtmlParser from "react-html-parser";
import { combineDispatchers, popupDispatcher } from '../store';

export const PopupType = {
  Warning: { icon: warningIcon, className: 'warning' },
  Info: { icon: infoIcon, className: 'info' },
  Error: { icon: errorIcon, className: 'error' }
};

export class FeasibilityResultPopupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: this.props.showPopup,
    
  };
}
  
message(props) {
  if(props.status == 'Ok'){
    return translate('Design feasible.')
  }
  else if(props.status == 'Error'){
    return translate('Design not feasible.')
  }
}

description(props){
  if(props?.description){
    let text = props.description;
    return ReactHtmlParser(text);
  }
}

  render () {
    const {
      text,
    } = this.props;

    return this.state.showPopup? <div className="status-popup">
      <div className='result-right' style={{paddingLeft: "20px", paddingBottom: "10px"}}>
        
      <div style={{ paddingTop: "20px", paddngRight: "20px"}}>
        <small>{this.description(this.props)}</small>
        </div>
        <br></br>
        <div style={{fontSize:"medium", fontWeight:"bold"}}>{this.message(this.props)}</div>
        <div  className="content-text-line"><p>{text.map((item, i)=> <div key={i}><br></br>{ReactHtmlParser(item)}<br></br></div>)}</p>
        <br/>
        </div>
      </div>
    </div>: null
  }
}

FeasibilityResultPopupComponent.PropTypes = {
  actionText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf( [PopupType.Warning, PopupType.Info, PopupType.Error, null] )
};

export const FeasibilityResultPopup = connect(combineDispatchers( popupDispatcher))(FeasibilityResultPopupComponent);